// src/components/NFTSimulator/rarityConfig.js
export const RARITY_TIERS = {
  COMMON: { emoji: '•', color: '#ffffff', label: 'Common', bgColor: 'rgba(255,255,255,0.1)' },
  UNCOMMON: { emoji: '⭐', color: '#4dffea', label: 'Uncommon', bgColor: 'rgba(77,255,234,0.15)' },
  RARE: { emoji: '🔥', color: '#ff9900', label: 'Rare', bgColor: 'rgba(255,153,0,0.15)' },
  ULTRA_RARE: { emoji: '💎', color: '#ff66ff', label: 'Ultra Rare', bgColor: 'rgba(255,102,255,0.15)' }
};

export const TRAIT_RARITY = {
  hair: {
    'NONE': RARITY_TIERS.COMMON,
    'STRINGY HAIR': RARITY_TIERS.UNCOMMON,
    'WILD HAIR': RARITY_TIERS.UNCOMMON,
    'WILDER HAIR': RARITY_TIERS.UNCOMMON,
    'WILDEST HAIR': RARITY_TIERS.UNCOMMON,
    'FRUMPY HAIR': RARITY_TIERS.UNCOMMON,
    'MESSY HAIR': RARITY_TIERS.UNCOMMON,
    'SIDE HAIR': RARITY_TIERS.UNCOMMON,
    'CRAZY HAIR': RARITY_TIERS.UNCOMMON,
    'MOHAWK': RARITY_TIERS.UNCOMMON,
    'MOHAWK THIN': RARITY_TIERS.UNCOMMON,
    'TINY MOHAWK': RARITY_TIERS.UNCOMMON,
    'HALF SHAVED': RARITY_TIERS.UNCOMMON,
    'STRAIGHT HAIR': RARITY_TIERS.UNCOMMON,
    'PIGTAILS': RARITY_TIERS.UNCOMMON,
    'BOB HAIR': RARITY_TIERS.UNCOMMON,
    'PLAIN HAIR': RARITY_TIERS.UNCOMMON,
    'SHORT HAIR': RARITY_TIERS.UNCOMMON,
    'CLOWN HAIR': RARITY_TIERS.UNCOMMON
  },
  eyewear: {
    'NONE': RARITY_TIERS.COMMON,
    'NERD GLASSES': RARITY_TIERS.UNCOMMON,
    'HORN RIMMED': RARITY_TIERS.UNCOMMON,
    'CLASSIC SHADES': RARITY_TIERS.UNCOMMON,
    'EYE PATCH': RARITY_TIERS.UNCOMMON,
    'REGULAR SHADES': RARITY_TIERS.UNCOMMON,
    '3D GLASSES': RARITY_TIERS.RARE,
    'VR HEADSET': RARITY_TIERS.UNCOMMON,
    'BIG SHADES': RARITY_TIERS.UNCOMMON,
    'WELDING GOGGLES': RARITY_TIERS.UNCOMMON,
    'EYE MASK': RARITY_TIERS.UNCOMMON,
    'SMALL SHADES': RARITY_TIERS.UNCOMMON
  },
  headwear: {
    'NONE': RARITY_TIERS.COMMON,
    'TOP HAT': RARITY_TIERS.UNCOMMON,
    'COWBOY HAT': RARITY_TIERS.UNCOMMON,
    'HOODIE': RARITY_TIERS.UNCOMMON,
    'CAP': RARITY_TIERS.UNCOMMON,
    'HELMET': RARITY_TIERS.UNCOMMON,
    'KNITTED CAP': RARITY_TIERS.UNCOMMON,
    'TASSLE HAT': RARITY_TIERS.UNCOMMON,
    'PILOT HELMET': RARITY_TIERS.RARE,
    'PINK WIF HAT': RARITY_TIERS.UNCOMMON,
    'HEADBAND': RARITY_TIERS.UNCOMMON
  },
  accessory1: {
    'NONE': RARITY_TIERS.COMMON,
    'ROSY CHEEKS': RARITY_TIERS.UNCOMMON,
    'SPOTS': RARITY_TIERS.UNCOMMON,
    'MOLE': RARITY_TIERS.UNCOMMON,
    'GOLD CHAIN': RARITY_TIERS.RARE,
    'TIARA': RARITY_TIERS.RARE,
    'CHOKER': RARITY_TIERS.RARE
  },
  accessory2: {
    'NONE': RARITY_TIERS.COMMON,
    'EYE SHADOW': RARITY_TIERS.RARE,
    'CLOWN EYES': RARITY_TIERS.RARE,
    'CLOWN NOSE': RARITY_TIERS.RARE
  },
  accessory3: {
    'NONE': RARITY_TIERS.COMMON,
    'L EARRING': RARITY_TIERS.UNCOMMON,
    'R EARRING': RARITY_TIERS.UNCOMMON,
    'EARRINGS': RARITY_TIERS.RARE,
    'PIPE': RARITY_TIERS.RARE,
    'MASK': RARITY_TIERS.ULTRA_RARE
  }
};